export default {
  data() {
    return {
      boardName: "",
    };
  },
  mounted() {
    this.getBoardDetails(this.$route.params.boardId);
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    kanbanData() {
      return this.$store.state.kanban.kanbanData;
    },
  },
  methods: {
    getBoardDetails(boardId) {
      if (!this.boardName) {
        this.$store
          .dispatch("boards/fetchBoardDetails", boardId)
          .then((res) => {
            if (res && res.data) {
              this.boardName = res.data.title;
            }
          })
          .catch((err) => {});
      }
    },
  },
};
